var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-block blog-quote"},[_c('div',{staticClass:"blog-quote__content",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }